import { Link } from "gatsby";
import React from "react";

const Header = () => {
  return (
    <header>
      <h1>
        <Link to={"/"}>
          Porn VR List
        </Link>
      </h1>
    </header>
  );
};

export default Header;
